import { useState } from 'react'
import './style.css'

const faqs = [
  {
    question: 'Where is Life Sports Club located?',
    answer: 'Life Sports Club is located on Mohammed Nagib Axis in New Cairo, Egypt',
  },
  {
    question: 'What sports are available at the club?',
    answer: 'We are building a diverse offering of 20+ sports and activities at Life Sports Club. Our current academies include Boys Football, Girls Football, Basketball, Handball, Dodgeball, Tennis, Padel, Swimming, Motor Skills, Flag Football, and Beach Volleyball. More academies will be introduced as we continue to grow.',
  },
  {
    question: 'How do I become a member?',
    answer: 'You can apply for membership through a referral code from an existing member or by contacting us directly to learn more about membership and the application process.',
  },
  {
    question: 'Are there sports academies for kids and adults?',
    answer: 'Yes — we offer professional sports academies for both kids and adults across multiple disciplines, coached by experienced trainers.',
  },
]

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null)

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="faq-section" aria-label="Frequently Asked Questions">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item${openIndex === index ? ' faq-item--open' : ''}`}>
            <button
              className="faq-question"
              onClick={() => toggle(index)}
              aria-expanded={openIndex === index}
            >
              {faq.question}
              <span className="faq-icon" aria-hidden="true">{openIndex === index ? '−' : '+'}</span>
            </button>
            {openIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}
